import { render, staticRenderFns } from "./WidgetVatEuropean.vue?vue&type=template&id=5e509508&"
import script from "./WidgetVatEuropean.vue?vue&type=script&lang=js&"
export * from "./WidgetVatEuropean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports